export default __webpack_public_path__ + "static/media/total_supply.b885fb58.svg";